import {
  IonApp,
  IonRouterOutlet,
  IonSplitPane,
  setupIonicReact,
} from "@ionic/react";
import { IonReactRouter } from "@ionic/react-router";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { ENV } from "hub/src/appConstants/env";
import MainContentWrapper from "hub/src/components/mainContent/MainContentWrapper";
import HubSideMenu from "hub/src/components/sideMenu/HubSideMenu";
import { PlatformSpecificAppLinksInterceptor } from "hub/src/context/AppLinksInterceptor";
import { PlatformSpecificQueryClientProvider } from "hub/src/context/PlatformSpecificQueryClientProvider";
import { HubReviewsContextProvider } from "hub/src/context/reviews/HubReviewsContext";
import { UserHubCustomRouterProvider } from "hub/src/context/UserHubCustomRouterProvider";
import { UserHubCustomSessionProvider } from "hub/src/context/UserHubCustomSessionProvider";
import "../styles/index.css";
import UserHubRoutes from "hub/src/routes/UserHubRoutes";

setupIonicReact({
  mode: "md",
});

const App: React.FC = () => {
  return (
    <IonApp>
      <PlatformSpecificQueryClientProvider>
        <IonReactRouter basename={ENV.REACT_BASE_PATH}>
          <UserHubCustomRouterProvider>
            <PlatformSpecificAppLinksInterceptor>
              <UserHubCustomSessionProvider>
                {/* TODO: We should pull the min-width value from our css variables for screen size of tablet
          to ensure it is consistent and managed in only one place. However, unsure of how to pull a css
          variable into html/js without a hacky, brittle solution.*/}
                <HubReviewsContextProvider>
                  <IonSplitPane
                    contentId="main-content"
                    when="(min-width: 768px)"
                  >
                    {!ENV.REACT_APP_HIDE_SIDEBAR && <HubSideMenu />}
                    <IonRouterOutlet
                      id="main-content"
                      basePath={ENV.REACT_BASE_PATH}
                    >
                      <MainContentWrapper className="h-full w-full">
                        <UserHubRoutes />
                      </MainContentWrapper>
                    </IonRouterOutlet>
                  </IonSplitPane>
                </HubReviewsContextProvider>
              </UserHubCustomSessionProvider>
            </PlatformSpecificAppLinksInterceptor>
          </UserHubCustomRouterProvider>
        </IonReactRouter>
        <ReactQueryDevtools initialIsOpen={false} position="bottom-right" />
      </PlatformSpecificQueryClientProvider>
    </IonApp>
  );
};

export default App;
